import React from "react";
import {
  formatCurrency,
  formatInteger,
  sortStatus,
  statusColor,
  statusLabel,
} from "./dashboardFormat";

// Onde as compras param: cada status com a sua fatia das transações abertas.
//
// Barras desenhadas à mão, e não um gráfico: cada linha precisa do rótulo, da
// contagem E do valor lado a lado, e é isso que responde "quanto dinheiro está
// preso no boleto que ninguém pagou".

export default function StatusChart({ status = [], openedTransactions = 0 }) {
  if (status.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        Nenhuma transação registrada para este evento.
      </div>
    );
  }

  const biggest = Math.max(...status.map((row) => row.transactions), 1);

  return (
    <div>
      {sortStatus(status).map((row) => {
        const width = Math.max(2, Math.round((row.transactions / biggest) * 100));
        const share = openedTransactions > 0 ? Math.round((row.transactions / openedTransactions) * 100) : 0;

        return (
          <div key={row.status} className="mb-3">
            <div className="d-flex justify-content-between align-items-baseline mb-1">
              <span style={{ fontSize: "13px", fontWeight: 600, color: "#1f2937" }}>
                {statusLabel(row.status)}
              </span>
              {/* Contagem e valor em colunas próprias, alinhadas à direita: os
                  valores de uma linha para a outra terminam na mesma coluna, e
                  dá para comparar a ordem de grandeza sem ler dígito a dígito.
                  `tabular-nums` mantém a largura do algarismo, sem a qual o "1"
                  desalinha a coluna inteira. */}
              <span style={{ display: "flex", alignItems: "baseline", gap: "10px", fontSize: "12.5px", color: "#495057" }}>
                <span style={{ minWidth: "52px", textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
                  {formatInteger(row.transactions)}
                </span>
                <span style={{ minWidth: "118px", textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
                  {formatCurrency(row.amount)}
                </span>
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ flexGrow: 1, height: "10px", background: "#eff2f7", borderRadius: "5px" }}>
                <div
                  style={{
                    width: `${width}%`,
                    height: "10px",
                    background: statusColor(row.status),
                    borderRadius: "5px",
                  }}
                />
              </div>
              <span style={{ fontSize: "11.5px", color: "#74788d", width: "38px", textAlign: "right" }}>
                {share}%
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
